const getActiveFilters = (defaultFilters: any, extendedFilters?: any, isMobileDisplay: boolean = false) => {
  const filters = isMobileDisplay ? defaultFilters : extendedFilters;
  const isActive = Object.values(defaultFilters).some((value) => value === true);
  const activeFilters = Object.values(filters || {}).filter((value) => value === true).length;

  return { isActive, activeFilters };
};

export default getActiveFilters;
